import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoggedIn } from '../../../../features/account/account.slice';

const EditUsernameForm = ({closeModal, setServerMessage, userEmail, refreshData, refreshCookies}) => {

  const [username, setUsername] = useState('');
  const [processing, setProcessing] = useState(false);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();

  const changeUsername = async () => {
    const response = await fetch(`${apiUrl}/user/editusername`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        username: username,
        email: userEmail,
      }),
    });

    if (response.status === 401) {
      // Unauthorized, possibly session expired
      dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
      return;
    };

    const data = await response.json();

    if(data.success === true) {
      setServerMessage(data);
      // set change to local storage
      localStorage.setItem('username', username);
    } else {
      setServerMessage(data);
    }
  };

  const validateUsername = () => {
    if (username === '') {
      setServerMessage({success: false, message: 'Please enter a new username'});
      return false;
    }
    if (username.length < 3) {
      setServerMessage({success: false, message: 'Username must be at least 3 characters long'});
      return false;
    }
    if (username.length > 20) {
      setServerMessage({success: false, message: 'Username must be at most 20 characters long'});
      return false;
    }
    if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      setServerMessage({success: false, message: 'Username can only contain letters, numbers, and underscores'});
      return false;
    }
    if (/^\d/.test(username)) {
      setServerMessage({success: false, message: 'Username cannot start with a number'});
      return false;
    }

    return true;
  }

  const handleSubmit = async () => {
    // Handle the username change logic here

    setProcessing(true); // Set processing state to true to disable the button
    if (validateUsername() === false) {
      // If validation fails, set the server message and return
      setProcessing(false);
      return;
    }

    try {
      // Call the API to change the username
      await changeUsername();
      // Refresh the cookies to get the new tokens
      await refreshCookies();
      // Refresh the user data after changing the username
      await refreshData();
      // Reset the username input field
      setUsername('');
      //call the function to close the modal
      closeModal();
    } catch (error) {
      console.error("Error changing username:", error);
    }

    setProcessing(false); // Reset processing state
  }

  return (
    <div className=''>
      <h4 className='ms-1 mb-3'>Change Username</h4>
      <input
        className="custom-input rounded"
        type="text"
        placeholder="New Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
        onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
        style={{
            height: "45px",
            backgroundColor: "#171A29",
            width: "100%", // Ensure the input takes the full width of the container
            paddingRight: "40px", // Add padding to make space for the icon
            border: "1px solid #3C3E4C",
            color: "white",
        }}
      />
      <div className='d-flex justify-content-center align-items-center mt-4'>
        <button 
          className='rounded w-100' style={{ backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, border: "none", color: "black" }}
          disabled={processing}
          onClick={() => {
            handleSubmit(); // Call the submit handler
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  )
}

export default EditUsernameForm